import { render, staticRenderFns } from "./ModalAtualizacaoBases.vue?vue&type=template&id=19e733e2&scoped=true&lang=pug"
import script from "./ModalAtualizacaoBases.vue?vue&type=script&lang=js"
export * from "./ModalAtualizacaoBases.vue?vue&type=script&lang=js"
import style0 from "./ModalAtualizacaoBases.vue?vue&type=style&index=0&id=19e733e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e733e2",
  null
  
)

export default component.exports